import CloseIcon from "@mui/icons-material/Close";
import DoneAllRoundedIcon from "@mui/icons-material/DoneAllRounded";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { FC } from "react";
import { RequestParticipant } from "models/interfaces";
import strings from "global/constants/StringConstants";
import { getStatusMessage } from "../SignRequestHelper";

interface CustomProps {
  requestStatus: string;
  currentReviewer: RequestParticipant;
  reviewers: RequestParticipant[];
  handleApproveRejectRequest: Function;
}

const ReviewerAction: FC<CustomProps> = ({
  requestStatus,
  currentReviewer,
  reviewers,
  handleApproveRejectRequest,
}) => {
  const theme = useTheme();

  const renderButtons = () => (
    <>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="outlined"
          onClick={() => handleApproveRejectRequest(false)}
          endIcon={<CloseIcon fontSize="small" />}
        >
          {strings.reject}
        </Button>
        <Button
          variant="contained"
          onClick={() => handleApproveRejectRequest(true)}
          endIcon={<DoneAllRoundedIcon fontSize="small" />}
        >
          {strings.approve}
        </Button>
      </Box>
    </>
  );

  const renderStatusMessage = () => {
    const message = getStatusMessage(requestStatus, currentReviewer, reviewers);
    if (!message) return null; // return nothing if handled elsewhere
    return (
      <Typography
        variant="subtitle2"
        sx={{ color: theme.palette.primary.main, fontWeight: 600 }}
      >
        {message}
      </Typography>
    );
  };

  // Final rendering
  if (
    currentReviewer.status === strings.pending &&
    requestStatus === strings.inReview
  ) {
    return renderButtons();
  }

  return renderStatusMessage();
};

export default ReviewerAction;
